import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config";
import { agent } from "../../../api";
import { FortuneWheelEntity, WheelEntityeUpdate, WheelEntityGlobal } from "../../../entities/wheelGame_v2";
import { addNotification } from "../../Notification/notificateStore";
import { handlerNeedUpdate } from "../fortuneWheelTableStore";

const wheelGameUrl = apiUrlV1 + "/v2/organization/game/fortunewheel";

export const getWheelEntityThemes = createAsyncThunk(
  'fotune-wheel/get-entity-themes',
  async (): Promise<string[]> => {
    try {
      const response = await agent.get(`${wheelGameUrl}/read/theme-list`);

      if (response.ok) {
        const data = await response.json();
        return data.themes as string[];
      }

      return []
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const getWheelEntity = createAsyncThunk(
  'fotune-wheel/get-entity-by-id',
  async (param: { id: number }): Promise<FortuneWheelEntity> => {
    try {
      const response = await agent.get(`${wheelGameUrl}/read/${param.id}`)
      if (response.ok) {
        const data = await response.json() as FortuneWheelEntity;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const postWheelEntity = createAsyncThunk(
  'fotune-wheel/post-entity-by-id',
  async (param: { data: WheelEntityGlobal }, thunksApi): Promise<FortuneWheelEntity> => {
    try {
      const response = await agent.post(`${wheelGameUrl}/create/from-global-settings`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelEntity;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));

        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchWheelEntity = createAsyncThunk(
  'fotune-wheel/patch-entity-by-id',
  async (param: { data: WheelEntityeUpdate, id: number }, thunksApi): Promise<FortuneWheelEntity> => {
    try {
      const response = await agent.patch(`${wheelGameUrl}/update/from-config-part/${param.id}`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelEntity;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)